import React from 'react'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'

import { ThemeColor } from 'utils/themes/types'

interface CheckboxProps {
  size?: number
  style?: 'square' | 'circle'
  selected?: boolean
  iconColor?: ThemeColor
  selectedColor?: ThemeColor
  boundaryColor?: ThemeColor
}

export const Checkbox = ({
  size = 22,
  style = 'circle',
  selected = false,
  iconColor = 'white',
  selectedColor = 'v2primary',
  boundaryColor = 'greyDark',
}: CheckboxProps) => {
  return (
    <Box
      width={size}
      height={size}
      align='center'
      justifyContent='center'
      padding={{ top: 'xxs' }}
      borderRadius={style === 'circle' ? 'lg' : 'xs'}
      border={{ width: 1, color: selected ? selectedColor : boundaryColor }}
      backgroundColor={selected ? selectedColor : 'white'}
    >
      {selected && <Icon size={size * 0.85} name='check' color={iconColor} />}
    </Box>
  )
}
